module.exports = __webpack_public_path__ + "img/bmsHome-lg.e835996f.jpg";